
(function($) {

  $.fn.navify = function() {
    var $mainMenu = this;
    var $secondLevelMenus = $mainMenu.find('> li > ul');
    var $thirdLevelMenus = $secondLevelMenus.find('> li > ul');
    var currentMenuLevel = 1;
    var menuLevel = 1;
    
    $.fn.navify.menu = $mainMenu;
    
    $(document).on('keydown', function(e) {
      if(e.which == 27) {
        console.log('escape key pressed, closing all these menus...');
        // closeOpenMenus($.merge($thirdLevelMenus, $secondLevelMenus));
        closeOpenMenus($secondLevelMenus);
        closeOpenMenus($thirdLevelMenus);
      }
    });
    
    $.fn.navify.menu.on('navify:toggleLevel2', function(event, $li, $submenu) {
      // console.log('navify:toggleLevel2 event fired');
      // var $menus = $secondLevelMenus.not($submenu);
      closeOpenMenus($secondLevelMenus.not($submenu));
      closeOpenMenus($thirdLevelMenus);
      $.fn.navify.toggleMenu($submenu);
    });
    
    
    $.fn.navify.menu.on('navify:toggleLevel3', function(event, $li, $submenu) {
      // console.log('navify:toggleLevel3 event fired');
      // var $menus = $thirdLevelMenus.not($submenu);
      closeOpenMenus($thirdLevelMenus.not($submenu));
      $.fn.navify.toggleMenu($submenu);
    });
    
    
    function closeOpenMenus($menus) {
      $menus.each(function(i, el) {
        // var $menu = $(el);
        // console.log($menu.css('opacity'));
        if($(el).css('opacity') != 0) {
          $.fn.navify.toggleMenu($(el));
        }
      });
    }
    
    return $.fn.navify.crawlMenu($mainMenu, menuLevel);
  }  

  $.fn.navify.crawlMenu = function($menu, menuLevel) {
    var $menu = $menu;
    var $topLevelListItems = $menu.find('> li');
    var $caretClone = $('<span class="caret" />').append('<span class="glyphicon glyphicon-menu-right" />');
    $menu.addClass(determineMenuClass(menuLevel));

    function determineMenuClass(menuLevel) {
      switch (menuLevel) {
        case 1:
          return 'level-one';
          break;
        case 2:
          return 'level-two sub-menu';
          break;
        case 3:
          return 'level-three sub-menu';
          break;
        default:
          return;
      }
    };
    

    $topLevelListItems.each(function(i, el) {
      var $this = $(el);
      $this.attr('data-link-index', i);

      if ($this.find('> ul').length) {
        $this.addClass('has-submenu');
        var $link = $this.find('> a');
        var $caret = $caretClone.clone();
        // This item has a submenu under it
        var $submenu = $this.find('> ul');
        // if this is a sub menu, hide it. Using .css instead of .hide
        // because it retains the initial display property this way
        // $submenu.css('display', 'none');
        // Insert caret after the link
        $link.after($caret);
        $caret.on('click', function(e) {
          e.stopPropagation();
          if(menuLevel == 1) {
            $.fn.navify.menu.trigger('navify:toggleLevel2', [$this, $submenu]);
          } else if (menuLevel == 2) {
            $.fn.navify.menu.trigger('navify:toggleLevel3', [$this, $submenu]);
          }
          // $caret.toggleClass('open');
          // $.fn.navify.toggleMenu($submenu);
        });
        // Crawl through submenu
        $.fn.navify.crawlMenu($submenu, menuLevel + 1);
      } else {
        // otherwise skip to the next item
        return;
      }
    });
  }

  $.fn.navify.toggleMenu = function($menu) {
    // $menu.slideToggle();
    console.log('toggling menu...');
    console.log($menu.parent());
    $menu.parent().toggleClass('open');
  };

  module.exports = $.fn.navify;

})(jQuery);
